import { getCmsAuthorizationHeaderObject, getCmsUrl, getDeepTranslationsFilter, serialize } from "@/services/cms";
import { httpClient } from "@/services/http";
import { LocaleCode } from "@/services/i18n";

import { getTermsAndConditionsResponseSchema } from "./get-terms-and-conditions.schema";
import type { GetTermsAndConditionsRequestProps } from "./get-terms-and-conditions.types";

export const GET_TERMS_AND_CONDITIONS_ENDPOINT = "/items/terms_and_conditions";

export const getTermsAndConditionsRequest = async ({ locale }: GetTermsAndConditionsRequestProps) => {
  const response = await httpClient
    .get(getCmsUrl(GET_TERMS_AND_CONDITIONS_ENDPOINT), {
      headers: getCmsAuthorizationHeaderObject(),
      params: {
        deep: {
          ...getDeepTranslationsFilter(LocaleCode.fromLocale(locale)),
        },
        fields: [
          "translations.heading",
          "translations.content",
          "translations.footer_text",
          "translations.footer_download_text",
          "translations.footer_download_url",
          "translations.header_text",
          "translations.update_date",
          "translations.pdf_url",
        ],
      },
      next: {
        tags: ["terms_and_conditions"],
        revalidate: false,
      },
      queryOptions: { arrayFormat: "comma" },
    })
    .then(serialize);

  return getTermsAndConditionsResponseSchema.parse(response);
};
